import { render } from "./ErrorLayout.vue?vue&type=template&id=7543f7c0"
import script from "./ErrorLayout.vue?vue&type=script&lang=js"
export * from "./ErrorLayout.vue?vue&type=script&lang=js"

import exportComponent from "/srv/www/network4web/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ErrorLayout.vue"]])

export default __exports__